import { StatusResponse } from '@/types/status';

// Hàm chuyển đổi status response thành message tiếng Việt
export const getStatusMessage = (status: StatusResponse, defaultMessage?: string): string => {
    const statusMessages: Record<StatusResponse, string> = {
        [StatusResponse.SUCCESS]: 'Thành công',
        [StatusResponse.FAIL]: 'Thất bại',
        [StatusResponse.FORBIDDEN]: 'Không có quyền truy cập',
        [StatusResponse.NOTFOUND]: 'Không tìm thấy',
        [StatusResponse.EXISTS_USERNAME]: 'Tên người dùng đã tồn tại',
        [StatusResponse.EXISTS_EMAIL]: 'Email đã tồn tại',
        [StatusResponse.USERNAME_OR_PASSWORD_IS_NOT_CORRECT]: 'Tên đăng nhập hoặc mật khẩu không chính xác',
        [StatusResponse.NOT_EXISTS_ROLE]: 'Vai trò không tồn tại',
        [StatusResponse.TYPE_ERROR]: 'Lỗi kiểu dữ liệu',
        [StatusResponse.USER_BY_ID_NOT_FOUND]: 'Không tìm thấy người dùng',
        [StatusResponse.VIDEO_BY_ID_NOT_FOUND]: 'Không tìm thấy video',
        [StatusResponse.EXISTS_CATEGORY]: 'Danh mục đã tồn tại',
        [StatusResponse.CATEGORY_BY_ID_NOT_FOUND]: 'Không tìm thấy danh mục',
        [StatusResponse.MOVIE_BY_ID_NOT_FOUND]: 'Không tìm thấy phim',
        [StatusResponse.EXISTS_MOVIE]: 'Phim đã tồn tại',
        [StatusResponse.EXISTS_COUNTRY]: 'Quốc gia đã tồn tại',
        [StatusResponse.COUNTRY_BY_ID_NOT_FOUND]: 'Không tìm thấy quốc gia',
        [StatusResponse.EXISTS_ACTOR]: 'Diễn viên đã tồn tại',
        [StatusResponse.ACTOR_BY_ID_NOT_FOUND]: 'Không tìm thấy diễn viên',
        [StatusResponse.ACTOR_NOT_FOUND]: 'Không tìm thấy diễn viên',
        [StatusResponse.EXISTS_DIRECTOR]: 'Đạo diễn đã tồn tại',
        [StatusResponse.DIRECTOR_BY_ID_NOT_FOUND]: 'Không tìm thấy đạo diễn',
        [StatusResponse.ERROR_CONNECT_MINIO_SERVER]: 'Lỗi kết nối MinIO server',
        [StatusResponse.OBJECT_ID_NOT_VALID]: 'ID không hợp lệ',
        [StatusResponse.ROLE_NOT_EXISTS]: 'Vai trò không tồn tại',
        [StatusResponse.EXISTS_DOMAIN]: 'Domain đã tồn tại',
        [StatusResponse.DOMAIN_BY_ID_NOT_FOUND]: 'Không tìm thấy domain',
        [StatusResponse.EXISTS_GROUP_DOMAIN]: 'Nhóm domain đã tồn tại',
        [StatusResponse.GROUP_DOMAIN_BY_ID_NOT_FOUND]: 'Không tìm thấy nhóm domain',
        [StatusResponse.YOU_NEED_TO_PROVIDE_ORIGIN]: 'Bạn cần cung cấp origin',
        [StatusResponse.YOUR_SITE_NOT_FOUND]: 'Không tìm thấy site của bạn',
        [StatusResponse.EXISTS_DYNADOT]: 'Dynadot đã tồn tại',
        [StatusResponse.DYNADOT_BY_ID_NOT_FOUND]: 'Không tìm thấy dynadot',
        [StatusResponse.EXISTS_NAME]: 'Tên đã tồn tại',
        [StatusResponse.NAME_BY_ID_NOT_FOUND]: 'Không tìm thấy tên',
        [StatusResponse.DOMAINNOTALLOWED]: 'Domain không được phép',
        [StatusResponse.DOMAIN_NOT_FOUND]: 'Không tìm thấy domain',
        [StatusResponse.EXISTS_AUTOMATIC_DOMAIN]: 'Domain tự động đã tồn tại',
        [StatusResponse.AUTOMATIC_DOMAIN_BY_ID_NOT_FOUND]: 'Không tìm thấy domain tự động',
        [StatusResponse.DOMAIN_ALREADY_EXISTS_CLOUDFLARE]: 'Domain đã tồn tại trên Cloudflare',
        [StatusResponse.DOMAIN_ALREADY_EXISTS]: 'Domain đã tồn tại'
    };

    return statusMessages[status] || defaultMessage || 'Có lỗi xảy ra';
};
